import React from 'react';
import { Server } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import Hospedagem from '../components/Hospedagem';

const SCHEMA = {
  "@type": "Service",
  "serviceType": "Hospedagem de sites e e-mails profissionais",
  "provider": { "@type": "LocalBusiness", "name": "Fernando Tech", "areaServed": "Brasil" },
  "description": "Hospedagem de sites, e-mails profissionais e domínios com suporte local da Fernando Tech: uptime, segurança e desempenho para o seu negócio.",
};

const FAQ = [
  { q: "A Fernando Tech oferece hospedagem de sites?", a: "Sim. Oferecemos hospedagem de sites, e-mails profissionais e registro de domínios com suporte local." },
  { q: "Tem e-mail profissional com meu domínio?", a: "Sim. Criamos e-mails com o seu domínio (ex.: contato@suaempresa.com.br)." },
  { q: "A hospedagem tem suporte de verdade?", a: "Sim. Você fala com a nossa equipe da Fernando Tech, sem depender de atendimento robotizado." },
  { q: "Vocês migram meu site atual?", a: "Sim. Fazemos a migração do seu site e e-mails para a nossa hospedagem sem complicação." },
  { q: "Qual plano de hospedagem é ideal para mim?", a: "Depende do tamanho do site e do tráfego. Fale conosco que indicamos o plano ideal." },
];

export default function HospedagemPage() {
  return (
    <SubjectPageLayout
      path="/hospedagem"
      breadcrumbName="Hospedagem"
      breadcrumbIcon={<Server className="w-3.5 h-3.5" />}
      seoTitle="Hospedagem de Sites e E-mails Profissionais | Fernando Tech"
      seoDescription="Hospedagem de sites, e-mails profissionais e registro de domínios com suporte da Fernando Tech: alta disponibilidade, segurança e desempenho. Planos para empresas e profissionais."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Hospedagem & E-mail',
        badgeIcon: <Server className="w-3.5 h-3.5" />,
        title: 'Hospedagem de Sites',
        accent: 'rápida, segura e com suporte de verdade',
        subtitle: 'Hospedagem de sites, e-mails profissionais e domínios com alta disponibilidade e suporte da Fernando Tech. Tenha desempenho e segurança para o seu site.',
      }}
      cta={{ heading: 'Precisa hospedar seu site ou e-mail?', text: 'Fale com a Fernando Tech e escolha o plano de hospedagem ideal, com suporte local e sem dor de cabeça.' }}
    >
      <Hospedagem />
    </SubjectPageLayout>
  );
}
